/* =========================================================================
   /event-planners — page behaviour.

   Everything here is decoration over markup that already reads correctly with
   no JavaScript at all:
     - the reveal class that HIDES content is added by this file, so a browser
       that never runs it shows the finished page rather than blank space;
     - every diagram is complete in the HTML, and the animations only replay
       what is already drawn;
     - prefers-reduced-motion switches off motion but never content.

   No dependencies. Loaded with `defer`.
   ========================================================================= */
(function () {
    'use strict';

    var root = document.getElementById('plan');
    if (!root) return;

    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var HAS_IO = 'IntersectionObserver' in window;

    /* ---------------------------------------------------------------------
       Subscribe. PlannerSubscription.subscribe() prompts sign-in inline when
       nobody is signed in and continues to Stripe afterwards, so there is
       nothing to branch on here.
       --------------------------------------------------------------------- */
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-planner-subscribe]');
        if (!btn) return;
        e.preventDefault();
        if (window.PlannerSubscription && window.PlannerSubscription.subscribe) {
            window.PlannerSubscription.subscribe();
        } else {
            // The script failed to load. A dead button is worse than a redirect.
            window.location.href = '/my-projects.html?planner_subscribe=1';
        }
    });

    /* ---------------------------------------------------------------------
       Scroll progress hairline under the sticky nav.
       --------------------------------------------------------------------- */
    (function progress() {
        var bar = document.getElementById('planProgress');
        if (!bar) return;
        var ticking = false;
        function paint() {
            ticking = false;
            var max = document.documentElement.scrollHeight - window.innerHeight;
            var p = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
            bar.style.transform = 'scaleX(' + p + ')';
        }
        window.addEventListener('scroll', function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(paint);
        }, { passive: true });
        paint();
    })();

    /* ---------------------------------------------------------------------
       Count-up. Reads its target off the element so the final value is in the
       markup and stays there if the animation never runs.
         data-count="188.00"  data-prefix="$"  data-suffix="+"
       --------------------------------------------------------------------- */
    function fmt(n, decimals, prefix, suffix) {
        return prefix + n.toLocaleString(undefined, {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        }) + suffix;
    }

    function countUp(el) {
        var target = parseFloat(el.getAttribute('data-count'));
        if (!isFinite(target)) return;
        var raw = el.getAttribute('data-count');
        var dot = raw.indexOf('.');
        var decimals = dot === -1 ? 0 : raw.length - dot - 1;
        var prefix = el.getAttribute('data-prefix') || '';
        var suffix = el.getAttribute('data-suffix') || '';
        var dur = 900;
        var t0 = null;

        function step(ts) {
            if (t0 === null) t0 = ts;
            var p = Math.min(1, (ts - t0) / dur);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = fmt(target * eased, decimals, prefix, suffix);
            if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
    }

    /* ---------------------------------------------------------------------
       Reveal on scroll, and the trigger for every scroll-driven diagram.

       One observer does both jobs: .reveal fades a block in, and the same
       .is-in class is what the stylesheet keys the diagram animations to.
       --------------------------------------------------------------------- */
    var animatable = root.querySelectorAll('.reveal, [data-anim]');

    function activate(el) {
        el.classList.add('is-in');
        el.querySelectorAll('[data-count]').forEach(function (n) {
            if (n.dataset.counted) return;
            n.dataset.counted = '1';
            if (!REDUCED) countUp(n);
        });
    }

    if (!HAS_IO) {
        animatable.forEach(activate);
    } else {
        if (!REDUCED) root.classList.add('js-reveal');
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
                if (!en.isIntersecting) return;
                activate(en.target);
                io.unobserve(en.target);
            });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
        animatable.forEach(function (el) { io.observe(el); });
    }

})();
